module.exports = require("prop-types");


//////////////////
// WEBPACK FOOTER
// external "prop-types"
// module id = 2
// module chunks = 0